export enum AllModules {
  // Sale modules
  SALE_FLAT = 'SALE_FLAT',
  SALE_HOUSE = 'SALE_HOUSE',
  SALE_PLOT = 'SALE_PLOT',
  SALE_OTHER = 'SALE_OTHER',

  // Rent modules
  RENT_FLAT = 'RENT_FLAT',
  RENT_HOUSE = 'RENT_HOUSE',
  RENT_PLOT = 'RENT_PLOT',
  RENT_OTHER = 'RENT_OTHER',

  // Other modules
  BAILIFF_NOTICE = 'BAILIFF_NOTICE',
  TENDER = 'TENDER',
  AUCTION = 'AUCTION',
  COOPERATIVE = 'COOPERATIVE'
}

export type AllModuleTypes = AllModules | string;
